'use client';

import { CallOffOrderColor, QuotedColor } from '@ravago/shared/page-data/models/elements';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   selected: CallOffOrderColor | QuotedColor | undefined;
   quantityAmount: number | undefined;
   selectedQuotationLineId: string | undefined;
   isAddingToCart: boolean;
   onContinueCallOff: (callOffOrderColor: CallOffOrderColor, quantity: number) => void;
   onAddToCart: () => void;
   onViewQuoteDetails: () => void;
}

export const OrderNowActions = ({ selected, quantityAmount, selectedQuotationLineId, isAddingToCart, onContinueCallOff, onAddToCart, onViewQuoteDetails }: Props) => {
   const translate = useTranslations();

   const handleContinueCallOff = () => {
      if (!selected || !('recommendedCallOff' in selected) || !quantityAmount) return;
      onContinueCallOff(selected, quantityAmount);
   };

   return (
      <>
         {selected && 'recommendedCallOff' in selected && (
            <Button data-testid="rfq-button__continue" fullWidth trailingIcon="long-arrow-right" disabled={!quantityAmount} onClick={handleContinueCallOff}>
               {translate('request-for-quotation.continue')}
            </Button>
         )}
         {selected && 'quotation' in selected && (
            <>
               <Button fullWidth onClick={onAddToCart} disabled={!selectedQuotationLineId || isAddingToCart}>
                  {translate('dynamic-product-block.add-to-cart')}
               </Button>
               <Button fullWidth variant="secondary" onClick={onViewQuoteDetails}>
                  {translate('dynamic-product-block.quote-details')}
               </Button>
            </>
         )}
      </>
   );
};

